import { HttpResourceRef } from '@angular/common/http';
import { Component, inject, Input, OnChanges, OnInit, signal, SimpleChanges } from '@angular/core';
import { FetchedDocument } from '../../documentation-chat';
import { BackendApiService } from '../../../../../services/backend-api.service';
import { Documentation } from '../../../documentation-overview/documentation';
import { KeyValueListComponent } from '../../../../../components/key-value-list/key-value-list/key-value-list.component';
import { KeyValueListItemComponent } from '../../../../../components/key-value-list/key-value-list-item/key-value-list-item.component';
import { RouterService } from 'projects/phito-core/src/lib/services/router.service';
import { DOCUMENTATION_ROUTES } from '../../../documentation.routes';

@Component({
    selector: 'phito-documentation-source',
    imports: [KeyValueListComponent, KeyValueListItemComponent],
    templateUrl: './documentation-source.component.html',
    styleUrl: './documentation-source.component.scss',
})
export class DocumentationSourceComponent implements OnInit {
    private api = inject(BackendApiService);
    private routerService = inject(RouterService);

    @Input() sources: FetchedDocument[] = [];
    documentations = signal<Documentation[]>([]);

    ngOnInit(): void {
        for (const s of this.sources) {
            this.api.getOne('documentations', s.id).subscribe({
                next: (response: Documentation) => {
                    this.documentations.update(arr => [...arr, response]);
                }
            });
        }
    }

    openDocumentation(docu: Documentation) {
        this.routerService.navNewTab(DOCUMENTATION_ROUTES.details, docu.id);
    }

}
